import React from 'react';
import { BellIcon, HelpCircleIcon } from 'lucide-react';
import { BrandLogo } from './brand/BrandLogo';
export function AppHeader() {
  return <header className="sticky top-0 z-20 w-full border-b border-slate-200 bg-white/95 backdrop-blur" data-id="element-1" data-mp="1stjvywiap2sv">
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-2" data-mp="27hww85of17t6">
        <div className="flex items-center gap-4" data-id="element-3" data-mp="22lpvcravmmi3">
          <BrandLogo data-id="element-4" data-mp="1et95vvot7s8r" />
          <span aria-hidden="true" className="hidden h-8 w-px bg-slate-200 sm:block" data-id="element-5" data-mp="1eukh2gkl429w" />
          <p className="hidden text-sm font-medium text-slate-500 sm:block" data-id="element-6" data-mp="19w9808245vsq">Loan Origination</p>
        </div>

        <div className="flex items-center gap-1.5" data-id="element-7" data-mp="1nwa9npq7d799">
          <button type="button" aria-label="Help" className="rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-700" data-id="element-8" data-mp="1jtdk1f28wavt">
            <HelpCircleIcon aria-hidden="true" className="h-4 w-4" data-id="element-9" data-mp="2vadae5518fn7" />
          </button>
          <button type="button" aria-label="Notifications" className="rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-700" data-id="element-10" data-mp="3m1074ke4ogce">
            <BellIcon aria-hidden="true" className="h-4 w-4" data-id="element-11" data-mp="3udh2vrk953v" />
          </button>
          <div className="ml-1.5 flex items-center gap-2.5" data-id="element-12" data-mp="33bl6us69nv92">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-700 text-xs font-semibold text-white" data-id="element-13" data-mp="338z0gvv43lsf">
              SW
            </span>
            <div className="hidden leading-tight sm:block" data-id="element-14" data-mp="3c9x7ln0uk9f8">
              <p className="text-sm font-medium text-slate-800" data-id="element-15" data-mp="3h2qd4d453lsd">Stephen Western</p>
              <p className="text-xs text-slate-400" data-id="element-16" data-mp="2jn2nwsbute2t">Loan Officer</p>
            </div>
          </div>
        </div>
      </div>
    </header>;
}